import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { departmentsSelector } from 'slices/departmentsSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/departmentsSlice';
import toast from 'react-hot-toast';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { Select } from 'components/common/Select';
import { IconButton } from '@mui/material';
import { fetchDepartments } from 'slices/departmentsSlice';
import { updateDepartment } from 'slices/departmentsSlice';
import { addDepartment } from 'slices/departmentsSlice';
import { typesSelector } from 'slices/typeSlice';
import { fetchTypes } from 'slices/typeSlice';

const apiService = new Api();
const AddDepartmentForm = ({ item, handleClose, callback, statusPerm }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm();
  const { types } = useSelector(typesSelector);
  const { error, loader } = useSelector(departmentsSelector);
  const [status, setStatus] = useState(1);
  const fileInputRef = React.useRef(null);
  const [localImage, setLocalImage] = React.useState('')
  const [noOfVariants, setNoOfVariants] = useState([
    {
      field: '',
    }
  ]);

  const resetFileInput = () => {
    setLocalImage("")
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset the file input value
    }
    setValue('name', '')
    setValue("address", '')
  };



  useEffect(() => {


    dispatch(fetchTypes(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }))


    setValue('name', item?.name || '')
    setValue("address", item?.address || '')


    setStatus((typeof (item?.status) == "number") ? item?.status : 1)
    // setValue('image', )
    dispatch(setError({}));




    resetFileInput()
    return () => {
      setValue("name");
      setValue("address");
      setStatus(1)
      resetFileInput()
      clearErrors("english_to_target")

      // cleanup code here
      // e.g. remove any subscriptions or timers
      // or reset any state variables

    }

  }, [item])


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchDepartments())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    data = {
      ...data,
      status,
    };

    if (item?.id) {
      dispatch(updateDepartment(data, item?.id, submitCallback));
    } else
      dispatch(addDepartment(data, submitCallback));

  }



  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>



        <div className="row-primary">
          <h2>Department Name *</h2>
          <Controller
            name="name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Department Name' required {...field} />}
          />
        </div>


        <div className="row-primary">
          <h2>Address *</h2>
          <Controller
            name="address"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='address' placeholder='Address' required {...field} />}
          />
        </div>


        {/* radio  */}
        {statusPerm &&
          <div className="row-primary template_switch" style={{ alignItems: "center" }}>
            <h2 className='m-0'>Status</h2>
            <CustomSwitch
              labelText="active"
              checked={status == 1 ? true : false}
              handleChange={(checked) => setStatus(checked ? 1 : 0)}
            />
          </div>
        }


        {error?.errors?.name?.map((error) => (
          <div style={{ marginTop: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}


        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            btnText={item?.id ? "Update" : "Create"}
            loader={loader}
          />
        </div>
      </form>

    </div>
  )
}

const AddDepartment = ({ item, onClose, callback, statusPerm }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} department</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddDepartmentForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddDepartment
